export default {
  title: "Adressen",

  input :{
    title: "Adres {{action}}",
    type: {
      label: "Type",
    },
    address: {
      label: "Adres",
    },
    street: {
      label: "Straat",
    },
    streetNumber: {
      label: "Huisnummer",
    },
    streetNumberAddition: {
      label: "Toevoeging",
      placeholder: "Huisnummer toevoeging",
    },
    postalCode: {
      label: "Postcode",
    },
    city: {
      label: "Stad",
      warning: {
        needCountry: "Selecteer eerst een land",
      },
    },
    country: {
      label: "Land",
    },
  },

  view: {
    noItems: {
      title: "Nog geen adressen",
      text: "Klik om een adres toe te voegen",
    },
    address: "Adres: ",
    street: "Straat: ",
  }
}
